// @flow

import { type PaymentSpec } from '@tectonics/prs/payment-spec';
import { type UserInputValidator, type UserInputValidationErrors } from '@tectonics/prs/validation';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type PrsSupport } from '@tectonics/prs/support';

type Args = {|
  +spec: PaymentSpec,
  +prsSupport: PrsSupport,
  +validateUserInput: UserInputValidator,
  +userInputValues: UserInputValues,
|};

export function mapUserInputValidation({
  spec,
  prsSupport,
  validateUserInput,
  userInputValues,
}: Args): UserInputValidationErrors {
  return Object.entries(userInputValues).reduce((current, [userInputName, userInputValue]) => {
    return {
      ...current,
      [userInputName]: validateUserInput({ spec, prsSupport, userInputName, userInputValue, userInputValues }),
    };
  }, {});
}
